import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withStyles, Snackbar, SnackbarContent } from './../../../../themes/default';
import { IconButton} from './../../../../themes/button';
import { CloseIcon, ErrorIcon, InfoIcon, WarningIcon, CheckCircleIcon } from './../../../../themes/icons';
import { green, amber } from './../../../../themes/colors';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  }
});

class SnackbarDefault extends React.Component {

  handleClose = (event, reason) => {
    this.props.AlertHide({ open: false, variant: this.props.Alert.variant, message: this.props.Alert.message })
  };

  render() {

    const { classes, Alert } = this.props;
    const variant = Alert.variant ? Alert.variant : 'info';
    const Icon    = variantIcon[variant];

    return (
      <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          open={ Alert.open }
          autoHideDuration={ Alert.duration ? Alert.duration : 6000 }
          onClose={ this.handleClose }
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
        >
        <SnackbarContent
          className={classNames(classes[variant])}
          message={
            <span id="system-message" className={ classes.message }>
              <Icon className={classNames( classes.icon, classes.iconVariant )} />
              { Alert.message }
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={ classes.close }
              onClick={ this.handleClose }
            >
              <CloseIcon className={classes.icon} />
            </IconButton>
          ]}
        />
        </Snackbar>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertHide: (data) => {
      dispatch({
        type: 'ALERT_HIDE',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SnackbarDefault));
